export default __webpack_public_path__ + "static/media/ai_lidarActive.0f12599a.svg";